import "core-js/modules/es6.string.small";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/flechounette.svg';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import MdmVideo from '~/components/atoms/Global/MdmVideo.vue';

var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

export default {
  name: 'LandingImageText',
  components: {
    MdmVideo: MdmVideo,
    GlobalRichText: GlobalRichText
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      hoverButton: false
    };
  },
  computed: {
    buttonStyle: function buttonStyle() {
      return {
        background: this.hoverButton ? this.currentPayload.button.color : this.currentPayload.button.background,
        color: this.hoverButton ? this.currentPayload.button.background : this.currentPayload.button.color,
        borderColor: this.currentPayload.button.background
      };
    },
    currentPayload: function currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20;

      return {
        richText: ((_ref20 = this.payload) != null ? (_ref20 = _ref20.primary) != null ? _ref20.rich_text : _ref20 : _ref20) || [],
        video: {
          alt: ((_ref19 = this.payload) != null ? (_ref19 = _ref19.primary) != null ? _ref19.alt : _ref19 : _ref19) || '',
          icon: ((_ref18 = this.payload) != null ? (_ref18 = _ref18.primary) != null ? _ref18.icon_name : _ref18 : _ref18) || '',
          iconColor: ((_ref17 = this.payload) != null ? (_ref17 = _ref17.primary) != null ? _ref17.icon_color : _ref17 : _ref17) || '',
          image: {
            small: formatPrismicImage((_ref16 = this.payload) != null ? (_ref16 = _ref16.primary) != null ? (_ref16 = _ref16.video_image) != null ? (_ref16 = _ref16.small) != null ? _ref16.url : _ref16 : _ref16 : _ref16 : _ref16) || EMPTY_PIXEL,
            medium: formatPrismicImage((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? (_ref15 = _ref15.video_image) != null ? (_ref15 = _ref15.medium) != null ? _ref15.url : _ref15 : _ref15 : _ref15 : _ref15) || EMPTY_PIXEL,
            large: formatPrismicImage((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? (_ref14 = _ref14.video_image) != null ? (_ref14 = _ref14.large) != null ? _ref14.url : _ref14 : _ref14 : _ref14 : _ref14) || EMPTY_PIXEL
          },
          url: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? (_ref13 = _ref13.video_url) != null ? _ref13.url : _ref13 : _ref13 : _ref13) || '',
          color: ((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? _ref12.video_play_color : _ref12 : _ref12) || '',
          tracking: {
            data: {
              event_category: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? _ref11.video_event_category : _ref11 : _ref11) || '',
              event_action: ((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? _ref10.video_event_action : _ref10 : _ref10) || '',
              event_label: ((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? _ref9.video_event_label : _ref9 : _ref9) || ''
            }
          }
        },
        button: {
          background: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? _ref8.button_color : _ref8 : _ref8) || '',
          color: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? _ref7.button_text_color : _ref7 : _ref7) || '',
          border: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? _ref6.button_color : _ref6 : _ref6) || '',
          text: ((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? _ref5.button_text : _ref5 : _ref5) || '',
          url: ((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? (_ref4 = _ref4.button_url) != null ? _ref4.url : _ref4 : _ref4 : _ref4) || '',
          tracking: {
            data: {
              event_category: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.event_category : _ref3 : _ref3) || '',
              event_action: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.event_action : _ref2 : _ref2) || '',
              event_label: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.event_label : _ref : _ref) || ''
            }
          }
        }
      };
    }
  }
};